<template>
  <div>
    <div class="header" @click="back">
      <i class="el-icon-back"/> | 场地详情
    </div>
    <el-row :gutter="40" class="panel-group">
      <el-col v-if="RoleId === 1" :xs="12" :sm="12" :lg="RoleId === 1?6:8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <div class="title">本月流水</div>
            <count-to :start-val="0" :end-val="fieldDetail?fieldDetail.amount:0" :duration="2600" :decimals="2" class="card-panel-num"/>
          </div>
          <div class="card-panel-description">
            <img src="@/assets/field-img-01.png" alt="">
          </div>
        </div>
      </el-col>
      <el-col v-if="RoleId !== 2" :xs="12" :sm="12" :lg="RoleId === 1?6:8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <div class="title">设备数量</div>
            <count-to :start-val="0" :end-val="fieldDetail?fieldDetail.deviceCount:0" :duration="2600" :decimals="0" class="card-panel-num"/>
          </div>
          <div class="card-panel-description">
            <el-progress :percentage="50" type="circle" color="#FF4040"/>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="RoleId === 1?6:8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <div class="title">昨日使用率(%)</div>
            <count-to :start-val="0" :end-val="fieldDetail?fieldDetail.yesterdayUseCount:0" :duration="2600" :decimals="2" class="card-panel-num"/>
          </div>
          <div class="card-panel-description">
            <img src="@/assets/field-img-02.png" alt="">
          </div>
        </div>
      </el-col>
      <el-col v-if="RoleId !== 2" :xs="12" :sm="12" :lg="RoleId === 1?6:8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <div class="title">柜门数</div>
            <count-to :start-val="0" :end-val="fieldDetail?fieldDetail.doorCount:0" :duration="2600" :decimals="0" class="card-panel-num"/>
          </div>
          <div class="card-panel-description">
            <img src="@/assets/field-img-03.png" alt="">
          </div>
        </div>
      </el-col>
    </el-row>
    <el-container>
      <el-aside width="70%" style="margin-right: 27px">
        <el-card class="el-custom-card custom-card" shadow="never">
          <div slot="header" class="clearfix">
            <el-row :gutter="10">
              <el-col :lg="24" class="mb-30">
                <b>设备列表 List device</b>
                <template v-if="calcPermission(permition, 1)">
                  <el-button class="custom-button" style="background: #FF834B;margin-left:auto" round @click="handleBindAgent">绑定代理商</el-button>
                  <!-- <el-col :lg="2">
                    <el-link type="primary">
                      <i class="el-icon-plus"/>
                      批量添加设备
                    </el-link>
                  </el-col> -->
                  <el-button class="custom-button" style="background: #FF834B;" round @click="handleAddDevice">新增设备</el-button>
                  <el-button class="custom-button" style="background: #1890FF;" round @click="handleBindField">绑定已添加设备</el-button>
                </template>
              </el-col>
              <el-col :md="4" :lg="4">
                <el-input v-model="deviceListQuery.identity" placeholder="请输入设备唯一标识号" size="medium"/>
              </el-col>
              <el-col :md="4" :lg="4">
                <el-input v-model="deviceListQuery.address" placeholder="请输入设备地址" size="medium"/>
              </el-col>
              <el-col :md="4" :lg="4">
                <el-select v-model="deviceListQuery.state" placeholder="请选择设备状态" size="medium" clearable >
                  <el-option
                    v-for="item in optionsStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
                </el-select>
              </el-col>
              <el-col :md="2" :lg="1">
                <el-button size="medium" type="primary" icon="el-icon-search" round @click="search">搜索</el-button>
              </el-col>

            </el-row>
          </div>

          <el-table
            :data="deviceData"
            fit
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              :label="$t('table.change')"
              fixed
              prop="Identity"
              type="selection"
              align="center"

            >
              <!-- <template>
              <el-checkbox v-model="checked">备选项</el-checkbox>
            </template>-->
            </el-table-column>
            <el-table-column
              :label="$t('table.imei')"
              prop="Identity"
              fixed="left"
              align="center"

            >
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.Identity" style="color: #409EFF">{{ scope.row.LsList.Identity }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('table.deviceName')"
              fixed="left"

              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.Name">{{ scope.row.LsList.Name }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="`场地名称`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.FieldName">{{ scope.row.FieldName }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="`代理商名称`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.AgentName">{{ scope.row.AgentName }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="`代理商手机号`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.AgentTel">{{ scope.row.AgentTel }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.address')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.Address">{{ scope.row.LsList.Address }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <!-- <template v-if="roleId === 1">
          <el-table-column :label="`是否隐藏`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.IsOpenHide">已隐藏</span>
              <span v-else>未隐藏</span>
            </template>
          </el-table-column>
          <el-table-column :label="`隐藏比例`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.HideProportion">{{ scope.row.LsList.HideProportion }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`隐藏基数`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.StartHideCount">{{ scope.row.LsList.StartHideCount }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </template>

        <el-table-column :label="$t('table.memberCount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.Count || 0 }}</span>
          </template>
        </el-table-column> -->
            <!-- <el-table-column :label="$t('table.maxMemberCount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.MemberCount || 0 }}</span>
            </template>
          </el-table-column> -->
            <!-- <el-table-column :label="$t('table.isDepositTel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.LsList.IsDepositTel === 'Y' ? '是' : scope.row.LsList.IsDepositTel === 'N' ? '否' : '--' }}</span>
          </template>
        </el-table-column> -->
            <el-table-column :label="$t('table.lineStatus')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.LineState === 'On' ? '在线' : scope.row.LineState === 'Off' ? '离线' : '--' }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column :label="$t('table.status')" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.LsList.StatusNo"
              >{{ scope.row.LsList.StatusNo === 'A' ? '管理员添加' : scope.row.LsList.StatusNo === 'S' ? '离线' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
            <!-- <el-table-column :label="$t('table.cellNum')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.BoxInfos ? scope.row.LsList.BoxInfos.length : '--' }}</span>
            </template>
          </el-table-column>-->
            <el-table-column :label="$t('table.userCount')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.UseTotalCount">{{ scope.row.LsList.UseTotalCount || 0 }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column v-if="RoleId === 1" :label="$t('table.totalIncome')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.LsList.TotalIncome || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.lastConnTime')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.LastLinkTime">{{ scope.row.LsList.LastLinkTime }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope="scope">
                <el-link
                  v-if="calcPermission(permition, 7) && scope.row.LsList.StatusNo === 'S'"
                  class="custom-link"
                  type="success"
                  @click="handleEnabled(scope.row)"
                >启用</el-link>
                <el-link
                  v-if="calcPermission(permition, 7) && scope.row.LsList.StatusNo === 'A'"
                  class="custom-link"
                  type="danger"
                  @click="handleDis(scope.row)"
                >禁用</el-link>
                <el-link
                  v-if="calcPermission(permition, 1)"
                  class="custom-link"
                  type="primary"
                  @click="handleDeviceEdit(scope.row.LsList)"
                >{{ $t('table.edit') }}</el-link>
                <el-link
                  v-if="calcPermission(permition, 7)"
                  class="custom-link"
                  type="primary"
                  @click="handleDetail(scope.row)"
                >详情</el-link>
                <el-dropdown v-if="calcPermission(permition, 4) || calcPermission(permition, 5) || calcPermission(permition, 6)">
                  <el-link type="primary">
                    <i class="el-icon-more"/>
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item>
                  <el-link
                    v-if="calcPermission(permition, 5)"
                    :underline="false"
                    class="custom-link"
                    @click="bindAgent(scope.row.LsList)"
                  >{{ $t('table.bindAgent') }}</el-link>
                </el-dropdown-item> -->
                    <el-dropdown-item>
                      <el-link
                        v-if="calcPermission(permition, 5) && scope.row.LsList.Url"
                        :underline="false"
                        class="custom-link"
                        @click="downQRcode(scope.row.LsList)"
                      >{{ $t('table.downloadQRcode') }}</el-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              v-show="deviceListTotal>0"
              :current-page="deviceListQuery.pageIndex"
              :page-sizes="[10,20,50,100]"
              :page-size="deviceListQuery.pageSize"
              :total="deviceListTotal"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
        <!-- 订单列表 -->
        <el-card class="el-custom-card custom-card mt-20" shadow="never">
          <div slot="header" class="clearfix">
            <el-row :gutter="10">
              <el-col :lg="24" class="mb-30">
                <b>订单流水 Order form </b>
              </el-col>
              <el-col :lg="4">
                <el-input v-model="orderListQuery.identity" placeholder="请输入设备唯一标识号" @change="handleInputChange"/>
              </el-col>
              <el-col :lg="6">
                <el-date-picker
                  v-model="value1"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleTimeChange"/>
              </el-col>
              <el-col :lg="2">
                <el-button type="primary" round icon="el-icon-search" @click="handleOrderSearch">搜索</el-button>
              </el-col>
            </el-row>
          </div>
          <el-table
            :data="orderData"
            fit
            style="width: 100%">
            <el-table-column
              label="订单编号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.OrderNo }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="收费模式"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.ChargingMode | fileterChangedDuration }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="场地名称"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.FieldName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备唯一标识号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Identity }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否有押金"
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.OrderInfo.IsDeposit"
                >{{ scope.row.OrderInfo.IsDeposit === 'Y'?'有押金':'无押金' }}</span>
                <span v-else>无押金</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.PayMoney') + '(元)'" width="100px" align="center">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.OrderInfo.PayMoney || scope.row.OrderInfo.PayMoney === 0"
                >{{ scope.row.OrderInfo.PayMoney }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column :label="`剩余押金(元)`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.OrderInfo.Deposit">{{ scope.row.OrderInfo.Deposit }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.boxNo')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.BoxNo }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.userName')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.UserInfo.UserName }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.telPhone')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.UserInfo.TelPhone }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.OrderType')" align="center">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.OrderInfo.OrderType"
                >{{ scope.row.OrderInfo.OrderType === 'box' ? '使用箱子' : scope.row.OrderInfo.OrderType === 'member' ? '会员充值' : '--' }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.OrderState')" align="center">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.OrderInfo.OrderState"
                >{{ scope.row.OrderInfo.OrderState === 'A' ? '进行中' : scope.row.OrderInfo.OrderState === 'D' ? '使用中' : scope.row.OrderInfo.OrderState === 'S' ? '订单结束' : '--' }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="`清理类型`" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.ClearMode | filteClearMode }}</span>
                <!-- <span v-else>0</span> -->
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.PayType')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.PayType === 'Wx' ? '微信支付' : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`存放时间`" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.StartTime }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.endTime')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.OrderInfo.EndTime || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-link v-if="(scope.row.OrderInfo.RetCoinStatus === 'ERROR' || scope.row.OrderInfo.RetCoinStatus === null) && scope.row.OrderInfo.ClearMode != 0" type="danger" @click="handleConfirmRefund(scope.row)">退款</el-link>
              </template>
            </el-table-column>

          </el-table>
          <div class="pagination-container">
            <el-pagination
              v-show="orderListTotal>0"
              :current-page="orderListQuery.pageIndex"
              :page-sizes="[10,20,50,100]"
              :page-size="orderListQuery.pageSize"
              :total="orderListTotal"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleOrderSizeChange"
              @current-change="handleOrderCurrentChange"
            />
          </div>
        </el-card>

        <!-- 新用户增长量 -->
        <el-card class="el-custom-card custom-card mt-20" shadow="never">
          <div slot="header" class="clearfix">
            <el-row :gutter="10">
              <el-col :lg="24" class="mb-30">
                <b>新用户增长量 Growth In New Users </b>
              </el-col>
              <!-- <el-col :lg="4">
                <el-input v-model="newUserListQuery.fieldId" placeholder="场地编号"/>
              </el-col> -->
              <el-col :lg="6">
                <el-date-picker
                  v-model="value2"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"/>
              </el-col>
              <el-col :lg="2">
                <el-button type="primary" round icon="el-icon-search" @click="getFieldUserOfGrowth">搜索</el-button>
              </el-col>
            </el-row>
          </div>
          <el-table
            :data="newUserList"
            fit
            style="width: 100%">
            <el-table-column
              label="用户数"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.UserCount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="最后清理时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.LastClearTime }}</span>
              </template>
            </el-table-column>

          </el-table>
          <div class="pagination-container">
            <el-pagination
              v-show="newUserListTotal>0"
              :current-page="newUserListQuery.pageIndex"
              :page-sizes="[10,20,50,100]"
              :page-size="newUserListQuery.pageSize"
              :total="newUserListTotal"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleUserOfGrowthSizeChange"
              @current-change="handleUserOfGrowthCurrentChange"
            />
          </div>
        </el-card>
      </el-aside>
      <el-main style="padding: 0">
        <el-card class="el-custom-card custom-card" shadow="never">
          <b>基本参数 The basic parameters</b>
          <p>场地名称：{{ fieldItem.FieldInfo.FieldName }}</p>
          <p>场地地址：{{ fieldItem.FieldInfo.Address }}</p>
          <p>场地管理员：{{ fieldItem.UserName }} --- <span style="color: #409EFF">手机号：{{ fieldItem.TelPhone }}</span> </p>
          <p>场地维护人员：{{ fieldItem.DefendName }} --- <span style="color:#409EFF">手机号：{{ fieldItem.DefendTel }}</span></p>
          <p>场地方分润比例：{{ fieldItem.FieldInfo.FieldProportion }}</p>
          <p>代理商分润比例：{{ fieldItem.FieldInfo.AgentProportion }}</p>
        </el-card>
        <el-card class="el-custom-card custom-card mt-20" shadow="never">
          <b>收费模式 Charge mode</b>
          <template v-if="fieldItem.FieldInfo.ChargingMode === 'Duration'">
            <template v-if="fieldItem.FieldInfo.DurationType === 'two'">
              <p>
                收费模式：{{ fieldItem.FieldInfo.ChargingMode | fileterChangedDuration }}
              </p>
              <p>
                时长模式：{{ fieldItem.FieldInfo.DurationType | fileterDurationMode }}
              </p>
              <p>
                前X小时：{{ fieldItem.FieldInfo.Hour }}
              </p>
              <p>
                是否免费：{{ fieldItem.FieldInfo.IsFree === 0?'不免费':'免费' }}
              </p>
              <p>
                前X小时箱子价格(元)：{{ fieldItem.FieldInfo.MidPrice01 }}
              </p>
              <p>
                箱子价格(元)：{{ fieldItem.FieldInfo.MidPrice }}
              </p>
              <p>
                箱子封顶价格(元)：{{ fieldItem.FieldInfo.MidCappingPrice }}
              </p>
            </template>
            <template v-else>
              <p>
                收费模式：{{ fieldItem.FieldInfo.ChargingMode | fileterChangedDuration }}
              </p>
              <p>
                时长模式：{{ fieldItem.FieldInfo.DurationType | fileterDurationMode }}
              </p>
              <p>
                X小时：{{ fieldItem.FieldInfo.Hour }}
              </p>
              <p>
                箱子价格(元)：{{ fieldItem.FieldInfo.MidPrice }}
              </p>
              <p>
                箱子封顶价格(元)：{{ fieldItem.FieldInfo.MidCappingPrice }}
              </p>
            </template>
          </template>
          <template v-else>
            <p>
              收费模式：{{ fieldItem.FieldInfo.ChargingMode | fileterChangedDuration }}
            </p>
            <template v-if="fieldItem.FieldInfo.ChargingMode === 'DurationStage'">
              <p>
                时间(分钟)：{{ item.S + '-' + item.E }}  价格：{{ item.P }}
              </p>
              <p>
                滞留最大时长(H)：{{ fieldItem.FieldInfo.Detention }}
              </p>
            </template>
            <template v-else-if="fieldItem.FieldInfo.ChargingMode === 'Month'">
              <p>
                箱子价格(元)：{{ fieldItem.FieldInfo.SmallPrice }}
              </p>
            </template>
            <template v-else>
              <p>
                箱子价格(元)：{{ fieldItem.FieldInfo.SmallPrice }}
              </p>
            </template>
          </template>
        </el-card>
        <el-card class="el-custom-card custom-card mt-20">
          <b>使用率 Usage</b>
          <line-chart :chart-data="lineChartData" title="使用率(%)"/>
        </el-card>
      </el-main>
    </el-container>

    <!-- 添加设备弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      title="添加设备"
      width="40%">
      <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="120px" class="demo-dataForm">
        <el-form-item label="设备唯一标识号" prop="Identity">
          <el-input v-model="dataForm.Identity" placeholder="请输入设备唯一标识号"/>
        </el-form-item>
        <el-form-item label="设备名称" prop="Name">
          <el-input v-model="dataForm.Name" placeholder="请输入设备名称"/>
        </el-form-item>
        <el-form-item label="设备地址" prop="Address">
          <el-input v-model="dataForm.Address" placeholder="请输入设备地址"/>
        </el-form-item>
        <!-- <el-form-item label="经度" prop="Longitude">
          <el-input v-model="dataForm.Longitude" placeholder="经度"/>
        </el-form-item>
        <el-form-item label="纬度" prop="Latitude">
          <el-input v-model="dataForm.Latitude" placeholder="纬度"/>
        </el-form-item> -->
        <!-- <el-form-item label="员工柜子数量" prop="MemberCount">
          <el-input v-model="dataForm.MemberCount" placeholder="员工柜子数量"/>
        </el-form-item> -->
        <el-form-item label="一拖几" prop="CabinetCount">
          <el-input v-model="dataForm.CabinetCount" placeholder="一拖几"/>
        </el-form-item>
        <el-form-item label="几门" prop="DoorCount">
          <el-input v-model="dataForm.DoorCount" placeholder="几门"/>
        </el-form-item>
        <el-form-item label="箱子编号" prop="BoxCode">
          <el-input v-model="dataForm.BoxCode" placeholder="箱子编号（A-Z）"/>
        </el-form-item>
        <el-form-item label="箱子备注" prop="MidMemo">
          <el-input v-model="dataForm.MidMemo" placeholder="箱子备注"/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleDialog('dataForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 绑定代理商弹窗 -->
    <el-dialog
      :visible.sync="bindAgentVisble"
      :before-close="handleClose"
      title="绑定代理商"
      width="30%">
      <div style="text-align: center; margin: 30px auto;">
        <el-select v-model="bindAgentDataForm.Id" filterable placeholder="请选择代理商">
          <el-option
            v-for="item in options"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button icon="el-icon-plus" round type="primary" @click="handleAddAgent"/>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindAgentVisble = false">取 消</el-button>
        <el-button type="primary" @click="confirmBindAgent">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加编辑代理商 -->
    <el-drawer
      ref="drawer"
      :before-close="handleClose"
      :visible.sync="dialog"
      title="添加代理商"
      direction="rtl"
      custom-class="demo-drawer"
    >
      <div class="demo-drawer__content">
        <el-form ref="form" :model="form" :rules="rulesForm">
          <el-form-item label="登录账号" label-width="100px" prop="LoginNo">
            <el-input v-model="form.LoginNo" placeholder="请输入登录账号"/>
          </el-form-item>
          <el-form-item v-if="userFlag" label="密码" label-width="100px" prop="Password">
            <el-input v-model="form.Password" type="password" placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item label="用户名" label-width="100px" prop="UserName">
            <el-input v-model="form.UserName" placeholder="请输入用户名"/>
          </el-form-item>
          <el-form-item label="手机号" label-width="100px" prop="TelPhone">
            <el-input v-model="form.TelPhone" placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item label="状态" label-width="100px" prop="StatusNo">
            <el-select v-model="form.StatusNo" placeholder="请选择">
              <el-option
                v-for="item in optionsStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <!-- <el-button :loading="loading" type="primary" @click="$refs.drawer.closeDrawer()">{{ '确 定' }}</el-button> -->
          <el-button type="primary" @click="handleConfirm">{{ '确 定' }}</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 下载二维码 -->
    <el-dialog :visible.sync="qrcode" title="下载二维码" width="30%">
      <div id="qrcod" ref="qrcode"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrcode = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 退款弹窗 -->
    <el-dialog
      :visible.sync="refundVisible"
      title="分订单"
      width="60%"
    >
      <el-table
        :data="splitOrderData"
        fit
        style="width: 100%">
        <el-table-column
          label="微信订单编号"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.OrderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="用户名"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.Phone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付金额"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.Money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.PayTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否退款"
        >
          <template slot-scope="scope">
            <el-link v-if="scope.row.RetCoinStatus === 'ERROR'" type="danger">退款失败</el-link>
            <el-link v-else-if="scope.row.RetCoinStatus === 'SUCCESS'" type="success">退款成功</el-link>
            <el-link v-else>未退款</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-link v-if="scope.row.flag && (scope.row.RetCoinStatus === 'ERROR' || scope.row.RetCoinStatus === null)" type="danger" @click="handleConfirmRefund(scope.row)">退款</el-link>
          </template>
        </el-table-column> -->

      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 场地添加设备弹窗 -->
    <el-dialog
      :visible.sync="bindDeviceVisible"
      :before-close="handleClose"
      title="场地绑定选择设备"
      width="30%">
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindDeviceDataForm.dIds" multiple placeholder="请选择设备号">
          <el-option
            v-for="item in deviceOptions"
            :key="item.DId"
            :label="item.Identity"
            :value="item.DId"/>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirmAddDevice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LineChart from '../dashboard/admin/components/LineChart'
import { qryDeviceInfo, txDevice, updateDeviceState, binDingAgent, binDingField } from '@/api/device'
import { qryFieldDetail, qryFieldUserIncrease } from '@/api/field'
import { qryOrderInfo, getSplitOrder, refund } from '@/api/order'
import { qryRoleInfo } from '@/api/baseModule'
import { qryUser, addUser, modUser } from '@/api/user'
import md5 from 'js-md5'
import QrCode from 'qrcodejs2'
import CountTo from 'vue-count-to'
export default {
  name: 'FieldDetail',
  components: {
    CountTo,
    LineChart
  },
  filters: {
    fileterChangedDuration(value) {
      let str = ''
      switch (value) {
        case 'Duration':
          str = '时长'
          break
        case 'Frequency':
          str = '次数'
          break
        case 'Month':
          str = '包月'
          break
        case 'DurationStage':
          str = '区间时长'
          break
        case 'Free':
          str = '免费'
          break
      }
      return str
    },
    fileterDurationMode(value) {
      let str = ''
      switch (value) {
        case 'two':
          str = '前X小时X元后续每一小时Z元'
          break
        case 'one':
          str = 'X小时X元'
          break
      }
      return str
    },
    filteClearMode(val) {
      let str = ''
      switch (val) {
        case 0:
          str = '用户'
          break
        case 1:
          str = '后台'
          break
        case 2:
          str = '自动'
          break
      }
      return str
    }
  },
  props: {
    fieldItem: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data() {
    var validatorLetter = (rule, value, callback) => {
      if (!value) {
        console.log(111)
        callback()
      } else {
        if (/^[A-Z]$/.test(value)) {
          callback()
        } else {
          callback(new Error('请填写A-Z之间的大写字母'))
        }
      }
    }
    return {
      newUserListTotal: 0,
      newUserList: [],
      newUserListQuery: {
        fieldId: null,
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      value1: null,
      value2: [],
      rules: {
        Identity: [
          { required: true, message: '请输入设备唯一标识', trigger: 'blur' }
        ],
        Name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        Address: [{ required: true, message: '请输入设备地址', trigger: 'blur' }],
        MemberCount: [{ required: true, message: '请输入最大员工柜子数量', trigger: 'blur' }],
        MidMemo: [{ required: false, message: '请输入中箱子备注', trigger: 'blur' }],
        BoxCode: [{ validator: validatorLetter, trigger: 'blur' }],
        CabinetCount: [
          { required: true, message: '请输入一拖几', trigger: 'blur' }
        ],
        DoorCount: [
          { required: true, message: '请输入柜门数', trigger: 'blur' }
        ]
      },
      rulesForm: {
        LoginNo: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        TelPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 1, max: 18, message: '长度在 1 到 18 个字符', trigger: 'blur' }
        ],
        StatusNo: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      form: {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      },
      optionsStatus: [
        {
          label: '启用',
          value: 'A'
        },
        {
          label: '禁用',
          value: 'S'
        }
      ],
      lineChartData: {
        actualData: [],
        addTime: []
      },
      deviceData: [], // 设备列表
      orderData: [], // 订单流水
      splitOrderData: [], // 分订单数据
      deviceListTotal: 0,
      orderListTotal: 0,
      dialog: false, // 代理商弹窗判断
      dialogVisible: false,
      bindAgentVisble: false,
      userFlag: true,
      qrcode: false,
      refundVisible: false,
      options: [], // 代理商用户数据
      listQuery: { // 查询代理商数据
        roleId: 2,
        pageIndex: 1,
        pageSize: 2147483647
      },
      bindDeviceVisible: false,
      deviceOptions: [],
      bindDeviceDataForm: {
        Id: null,
        dIds: []
      },
      dataForm: {
        Did: 0,
        Identity: null,
        FieldId: 0,
        Name: null,
        Address: null,
        Longitude: 0,
        Latitude: 0,
        MemberCount: 0,
        IsDepositTel: 'N',
        IsFree: 'N',
        BoxCode: null,
        MidMemo: null,
        IsOpenHide: 0,
        HideProportion: 0,
        StartHideCount: 0,
        MaxHideCount: 0,
        Province: null,
        City: null,
        Area: null,
        CabinetCount: null,
        DoorCount: null,
        typeNo: 'Small'
      },
      deviceListQuery: {
        fieldId: 0,
        identity: null,
        address: null,
        binDingAgent: null,
        notBinDingAgent: null,
        state: null,
        pageIndex: 1,
        pageSize: 10
      },
      orderListQuery: {
        identity: null,
        fieldIds: null,
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      bindAgentDataForm: {
        Id: null,
        dIds: []
      },
      qr: null,
      fieldDetail: null,
      RoleId: null
    }
  },
  computed: {
  },
  watch: {
    value2(value) {
      console.log(value)
      if (value) {
        this.newUserListQuery.startTime = value[0]
        this.newUserListQuery.endTime = value[1]
      } else {
        this.newUserListQuery.startTime = null
        this.newUserListQuery.endTime = null
      }
    }
  },
  created() {
    this.RoleId = this.$store.getters.roles.RoleId
    this.newUserListQuery.fieldId = this.deviceListQuery.fieldId = this.dataForm.FieldId = this.orderListQuery.fieldIds = this.fieldItem.FieldInfo.FieldId
    // this.dataForm.FieldId = this.orderListQuery.fieldIds = this.fieldItem.FieldInfo.FieldId
    console.log(this.fieldItem)
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.getDeviceList()
          this.getOrderList()
          this.getFieldDetail(this.fieldItem.FieldInfo.FieldId)
          this.getFieldUserOfGrowth()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            // console.log(response.LsList[0].RolePrograms)
            this.getDeviceList()
            this.getOrderList()
            this.getFieldDetail(this.fieldItem.FieldInfo.FieldId)
            this.getFieldUserOfGrowth()
          }
        })
      })
    }
  },
  methods: {
    // 获取场地新用户增长量
    getFieldUserOfGrowth() {
      qryFieldUserIncrease(this.newUserListQuery).then(res => {
        console.log(res)
        this.newUserList = res.LsList
        this.newUserListTotal = res.TotalRows
      })
    },
    // 获取场地详情
    getFieldDetail(fieldId) {
      qryFieldDetail({ fieldId }).then(res => {
        this.fieldDetail = res
        res.list.forEach(item => {
          this.lineChartData.actualData.push(item.Ratio)
          this.lineChartData.addTime.push(item.AddTime)
        })
      })
    },
    // 查询设备列表
    getDeviceList() {
      qryDeviceInfo(this.deviceListQuery).then(res => {
        console.log(res)
        if (res) {
          this.deviceData = res.LsList
          this.deviceListTotal = res.TotalRows
        }
      })
    },
    // 获取场地下订单信息列表
    getOrderList() {
      qryOrderInfo(this.orderListQuery).then(res => {
        console.log(res)
        if (res) {
          this.orderData = res.LsList.LsList
          this.orderListTotal = res.LsList.TotalRows
        }
      })
    },
    handleInputChange() {
      if (!this.orderListQuery.identity) {
        this.orderListQuery.identity = null
      }
    },
    // 订单时间切换
    handleTimeChange() {
      console.log(this.value1)
      if (this.value1) {
        this.orderListQuery.startTime = this.value1[0]
        this.orderListQuery.endTime = this.value1[1]
      } else {
        this.orderListQuery.startTime = null
        this.orderListQuery.endTime = null
      }
    },
    // 搜索
    search() {
      this.getDeviceList()
    },
    // 搜索订单
    handleOrderSearch() {
      this.getOrderList()
    },
    // 添加设备
    handleAddDevice() {
      this.dialogVisible = true
      console.log(this.dataForm)
    },
    // 点击空白关闭弹窗
    handleClose(done) {
      this.resetDataForm()
      this.resetForm()
      this.resetBindDeviceDataForm()
      this.deviceOptions.dIds = []
      done()
    },
    // 取消
    handleCancel() {
      this.resetDataForm()
      this.resetBindDeviceDataForm()
      this.deviceOptions.dIds = []
      this.dialogVisible = false
      this.bindDeviceVisible = false
    },
    // 确定弹窗
    handleDialog(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          txDevice(this.dataForm).then(res => {
            if (res) {
              this.$message.success('添加成功')
              this.getDeviceList()
              this.resetDataForm()
              this.dialogVisible = false
            }
          })
        }
      })
    },
    // 编辑设备信息
    handleDeviceEdit(item) {
      console.log(item)
      for (const key in this.dataForm) {
        this.dataForm[key] = item[key]
      }
      this.dataForm.Did = item.DId
      this.dialogVisible = true
      console.log(this.dataForm)
    },
    // 表格选中状态
    handleSelectionChange(e) {
      console.log(e)
      this.bindAgentDataForm.dIds = e.map(item => {
        return item.LsList.DId
      })
      console.log(this.bindAgentDataForm)
    },
    // 查询代理商数据
    getAgentList() {
      qryUser(this.listQuery).then(res => {
        this.options = res.LsList
      })
    },
    // 绑定代理商弹窗
    handleBindAgent() {
      if (!this.bindAgentDataForm.dIds.length > 0) {
        this.$message.error('请先选择设备')
        return
      }
      this.getAgentList()
      this.bindAgentVisble = true
    },
    getDeviceFilterList() {
      qryDeviceInfo({ pageIndex: 1, pageSize: 2147483647 }).then(res => {
        console.log(res)
        res.LsList.forEach(item => {
          if (!item.LsList.FieldId) {
            this.deviceOptions.push(item.LsList)
          }
        })
        console.log(this.deviceOptions)
      })
    },
    // 绑定设备弹窗
    handleBindField() {
      this.getDeviceFilterList()
      this.bindDeviceVisible = true
    },
    // 确定绑定设备
    handleConfirmAddDevice() {
      if (this.bindDeviceDataForm.dIds.length <= 0) {
        this.$message.error('请选择设备')
        return
      }
      this.bindDeviceDataForm.Id = this.fieldItem.FieldInfo.FieldId
      binDingField(this.bindDeviceDataForm).then(res => {
        if (res) {
          this.$message.success('绑定成功')
          this.getDeviceList()
          this.resetBindDeviceDataForm()
          this.deviceOptions.dIds = []
          this.bindDeviceVisible = false
        }
      })
    },
    resetBindDeviceDataForm() {
      this.bindDeviceDataForm = {
        Id: null,
        dIds: []
      }
      this.deviceOptions = []
    },
    // 添加代理商
    handleAddAgent() {
      this.userFlag = true
      this.dialog = true
    },
    // 确定绑定代理商
    confirmBindAgent() {
      if (!this.bindAgentDataForm.Id) {
        this.$message.error('请选择代理商')
        return
      }
      binDingAgent(this.bindAgentDataForm).then(res => {
        if (res) {
          this.$message.success('绑定成功')
          this.getDeviceList()
          this.bindAgentVisble = false
          console.log(res)
        }
      })
    },
    // 编辑代理商
    handleAgentEdit(item) {
      this.userFlag = false
      for (const key in this.form) {
        this.form[key] = item[key]
      }
      this.dialog = true
    },
    // 取消代理商弹窗
    cancelForm() {
      this.resetForm()
      this.dialog = false
    },
    // 弹窗确定提交
    handleConfirm() {
      console.log(this.form)
      this.form.Password = this.userFlag ? md5(this.form.Password) : this.form.Password
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.UserId) { // 修改
            modUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.$message.success('修改成功')
                this.dialog = false
                this.resetForm()
                this.getAgentList()
              }
            })
          } else {
            addUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.dialog = false
                this.resetForm()
                this.getAgentList()
              }
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      }
    },
    // 启用
    handleEnabled(row) {
      console.log(row)
      this.setState(row.LsList.DId, 'A')
    },
    // 禁用
    handleDis(row) {
      console.log(row)
      this.setState(row.LsList.DId, 'S')
    },
    // 设置用户状态
    setState(did, state) {
      updateDeviceState({
        did: did,
        state: state
      }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '设置状态成功'
          })
          this.getDeviceList()
        }
      })
    },
    // 重置dataForm
    resetDataForm() {
      this.dataForm = {
        Did: 0,
        Identity: null,
        FieldId: this.fieldItem.FieldInfo.FieldId,
        Name: null,
        Address: null,
        Longitude: 0,
        Latitude: 0,
        MemberCount: 0,
        IsDepositTel: 'N',
        IsFree: 'N',
        BoxCode: null,
        MidMemo: null,
        IsOpenHide: 0,
        HideProportion: 0,
        StartHideCount: 0,
        MaxHideCount: 0,
        Province: null,
        City: null,
        Area: null,
        CabinetCount: null,
        DoorCount: null
      }
    },
    // 设备详情
    handleDetail(item) {
      console.log(item)
      this.$router.push({ path: '/deviceList', query: item })
    },
    // 打开二维码下载界面
    downQRcode(detail) {
      this.qrcode = true
      this.detail = detail
      var Url = detail.Url
      this.$nextTick(() => {
        if (!this.qr) {
          this.qr = new QrCode('qrcod', {
            text: Url,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QrCode.CorrectLevel.H
          })
        } else {
          this.qr.makeCode(Url)
        }
      })
    },
    // 退款订单列表
    handleRefund(item) {
      console.log(item)
      this.getRefundList(item, 1)
      this.refundVisible = true
    },
    // 获取退款订单
    getRefundList(item, type) {
      const orderId = type ? item.OrderInfo.OrderId : item.OrderId
      getSplitOrder({ orderId, type: 'weixin' }).then(res => {
        if (type) {
          res.forEach(data => {
            data.Name = item.UserInfo.UserName
            data.Phone = item.UserInfo.TelPhone
          })
          res[res.length - 1].flag = true
        }

        this.splitOrderData = res
        console.log(res)
      })
    },
    // 退款确认
    handleConfirmRefund(item) {
      console.log(item)
      refund({ orderNo: item.OrderInfo.OrderNo }).then(res => {
        if (res) {
          this.$message.success('退款成功')
          // this.getRefundList(item, 0)
          // this.getOrderList()
          this.handleOrderSearch()
          this.refundVisible = false
        }
      })
    },
    handleSizeChange(e) {
      this.deviceListQuery.pageSize = e
      this.getDeviceList()
    },
    handleCurrentChange(e) {
      this.deviceListQuery.pageIndex = e
      this.getDeviceList()
    },
    handleOrderSizeChange(e) {
      this.orderListQuery.pageSize = e
      this.getOrderList()
    },
    handleOrderCurrentChange(e) {
      this.orderListQuery.pageIndex = e
      this.getOrderList()
    },
    handleUserOfGrowthSizeChange(e) {
      this.newUserListQuery.pageSize = e
      this.getOrderList()
    },
    handleUserOfGrowthCurrentChange(e) {
      this.newUserListQuery.pageIndex = e
      this.getOrderList()
    },
    back() {
      this.$emit('back')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";
.panel-group {
  margin-top: 18px;
  .card-panel-col{
    margin-bottom: 32px;
  }
  .card-panel {
    height: 168px;
    cursor: pointer;
    font-size: 24px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    // &:hover {
    //   .card-panel-icon-wrapper {
    //     color: #fff;
    //   }
    //   .icon-people {
    //      background: #40c9c6;
    //   }
    //   .icon-message {
    //     background: #36a3f7;
    //   }
    //   .icon-money {
    //     background: #f4516c;
    //   }
    //   .icon-shopping {
    //     background: #34bfa3
    //   }
    // }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #333;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shopping {
      color: #34bfa3
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
      .title{
        font-size: 22px;
        color: #999;
        margin-bottom: 24px;
      }
      .card-panel-num {
        font-size: 34px;
      }
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      text-align: right;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      img{
        height: 101px;
      }
    }
  }
}
.header{
  color: #409EFF;
  cursor: pointer;
  font-size: 16px;
}
.custom-col{
  margin-bottom: 15px;
}
.line{
  width: 100%;
  height: 1px;
  background-color: #eeeeee;
}
.demo-drawer__footer{
  text-align: center;
}
.demo-drawer__content{
  padding: 20px;
}
#qrcod img {
  margin: auto;
}
.custom-card{
  font-size: 16px;
  b{
    display: flex;
    align-items: center;
    &::before{
      content: '';
      display: inline-block;
      width: 4px;
      height: 18px;
      background-color: $menuTextActive;
      margin-right: 13px;
      border-radius: 5px;
    }
  }
  .mb-30{
    display: flex;
    align-items: center;
  }
  ::v-deep {
    .el-input__inner{
      border-radius: 70px;
    }
  }
}
.custom-button{
  color: white;
  border:none
}
</style>
